import { formatHoursValue, createKpiTileItem } from '../../../../utils/helper';
import { KpiHandler, IPCSummaryData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const totalHours: KpiHandler = {
  type: 'KpiTile',
  handler: (data: IPCSummaryData): KpiData => {
    const { totalHours } = data;

    const formattedValue = formatHoursValue(totalHours);

    return createKpiTileItem('Total Hours', formattedValue, []);
  },
};

export default totalHours;
